document.addEventListener("DOMContentLoaded", () => {
    /********************* Setup *********************/

        // return if the section has no info popover configured
    const infoBtn = document.querySelector("#announcementInfo");
    const popover = document.querySelector("#announcementPopover");
    if (!infoBtn || !popover) {
        return;
    }

    /********************* Events *********************/

    // toggle the info popover when the icon is clicked
    infoBtn.addEventListener("click", () => {
        const willOpen = !popover.classList.contains("active");
        popover.classList.toggle("active", willOpen);
        infoBtn.setAttribute("aria-expanded", willOpen);
    });

    // close the popover when clicking outside the icon or popover
    document.addEventListener("mousedown", (e) => {
        if (e.target.closest("#announcementInfo") || e.target.closest("#announcementPopover")) {
            return;
        }
        popover.classList.remove("active");
        infoBtn.setAttribute("aria-expanded", "false");
    });
});
